/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityaspecthumor2Inputs */



/**
* | output |
* | --- |
* | "Humor" |
*
* @param {Personalityaspecthumor2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityaspecthumor2 = /** @type {((inputs?: Personalityaspecthumor2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityaspecthumor2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Humor")
	if (locale === "es") return /** @type {LocalizedString} */ ("Humor")
	return /** @type {LocalizedString} */ ("Юмор")
});
export { personalityaspecthumor2 as "personalityAspectHumor" }